import { Image } from '../Image/Image';
import { MarkdownParagraph } from './MarkdownParagraph';
import { IMarkdownRenderers } from './IMarkdownRenderers';

export const defaultMarkdownRenderers: IMarkdownRenderers = {
	p: ({ node, ...props }) => <MarkdownParagraph {...props} />,
	img: ({ node, ...props }) => <Image {...props} />,
};
